module.exports = __webpack_public_path__ + "/images/swisspower-logo.small.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/images/swisspower-logo.small.png
// module id = 205
// module chunks = 0